import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';

class DriverRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }
  async getDrivers(includeOnlyUsers) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    let url = '';
    if (includeOnlyUsers) {
      url = `${this.lastmileApiUrl}/api/driver?provider=true&includeUsers=true`;
    } else {
      url = `${this.lastmileApiUrl}/api/driver?provider=true`;
    }
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      return [];
    }
  }
}

Container.set({ id: DriverRepository, type: DriverRepository });

export default DriverRepository;
